module.exports = __webpack_public_path__ + "img/magento-custom-development.d38311ff.jpeg";